import {
  REQUEST_THEMES, RECEIVE_THEMES, RECEIVE_THEME,
} from '../actions/themes';

const reducer = (state = {
  items: [],
  loading: false,
  item: {},
}, action) => {
  switch (action.type) {
    case REQUEST_THEMES:
      return { ...state, loading: true };
    case RECEIVE_THEMES:
      return { ...state, items: action.json.data, loading: false };
    case RECEIVE_THEME:
      return {
        ...state,
        item: action.json,
        loading: false,
      };
    default:
      return state;
  }
};

export default reducer;
